import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  setPointChecklist = "SET_POINT_CHECK_LIST",
  moveCircumPoints = "MOVE_CIRCUMFERENCE_POINTS",
  KiteMode = "KITE_MODE",
  Triangle1Mode ="TRIANGLE_1_MODE",
  Triangle2Mode = "TRIANGLE_2_MODE",
  genRanIntersec = "GENERATE_RANDOMLY_INTERSECTION"
}

export const eventBus = new EventEmitter();